"use client";

import { useAppBadge } from "@/hooks/useAppBadge";
import { usePathname } from "next/navigation";
import { ReactNode } from "react";

/** Syncs combined chat unread count to the PWA app icon badge. */
function AppBadge() {
  useAppBadge();
  return null;
}

/**
 * Wraps non-admin routes with the PWA chat-badge sync. Admin routes are
 * excluded so we don't attach a chat-inbox listener for users who are
 * exclusively organizing tournaments.
 *
 * Previously also provided the legacy ChatContext; removed in favor of the
 * unified `useChatInbox` hook, which each consumer now reads directly.
 */
export function ConditionalChatProvider({
  children,
}: {
  children: ReactNode;
}) {
  const pathname = usePathname();
  const isAdminRoute = pathname?.includes("/admin");

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <AppBadge />
    </>
  );
}
